import { trackGtmEvent } from '@src/scripts/lib/gtm';

globalThis.document.addEventListener(
	'dhsv-stage-filterbar-filters-changed',
	( e: CustomEvent ) => {
		const { filters, options } = e.detail;

		const themenschwerpunkt =
			options.sf_themenschwerpunkt_kurz &&
			filters.sf_themenschwerpunkt_kurz
				? options.sf_themenschwerpunkt_kurz.find(
						( { value }: { value: string } ) =>
							value === filters.sf_themenschwerpunkt_kurz
				  )?.label
				: '';

		trackGtmEvent( 'ga_event', {
			category: 'filter_usage',
			filter_graduation_level: filters.sf_abschlussart,
			filter_study_topic: themenschwerpunkt,
		} );
	}
);
